<portal-text-input
  [errors]="usernameMatErrors"
  [formControl]="accessorDirective.control"
  autocomplete="username"
  hint="info_text.input.personalNumber"
  label="label.personalNumber"
  placeholder="label.personalNumber" />
